"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWhitelistFiltering = exports.doFilterFacet = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const superstruct_1 = require("superstruct");
const FacetFilterService_1 = require("./FacetFilterService");
const FacetFilterExpEvaluator_1 = require("./FacetFilterExpEvaluator");
const FacetFilterOperators_1 = require("./FacetFilterOperators");
const FacetFilterUtils_1 = require("./FacetFilterUtils");
const Logger_1 = __importDefault(require("./Logger"));
const evaluator = new FacetFilterExpEvaluator_1.FacetFilterExpEvaluator(FacetFilterOperators_1.FACET_FILTER_OPERATORS);
function evaluateCondition(facets, cond, ref) {
    if (cond === undefined) {
        return true;
    }
    if (cond === null) {
        return false;
    }
    if (typeof cond === "boolean") {
        return cond;
    }
    return Boolean(evaluator.eval(cond, ref, facets));
}
function isFilterMatch(iPlain, iPattern, facetKey, ref) {
    const plain = facetKey ? `${facetKey}_${iPlain}` : iPlain;
    const [inverse, pattern] = (0, FacetFilterUtils_1.isInverse)(iPattern);
    const exp = `${plain} ${inverse ? "!in" : "in"} ${pattern}`;
    return Boolean(evaluator.eval(exp, ref));
}
function doFilter(data, filter, ref, facetKey) {
    if (filter == null || data == null) {
        return {};
    }
    if (filter === ".*") {
        return data;
    }
    if (typeof filter === "number" && typeof data === "number") {
        return filter === data ? data : {};
    }
    if (typeof filter === "string" && typeof data === "string") {
        return isFilterMatch(data, filter, facetKey, ref) ? data : {};
    }
    if (typeof filter === "object" && typeof data === "object") {
        const result = {};
        Object.entries(data).forEach(([dataKey, dataValue]) => {
            Object.entries(filter).forEach(([filterKey, filterValue]) => {
                if (isFilterMatch(dataKey, filterKey, facetKey, ref)) {
                    const subResult = doFilter(dataValue, filterValue, ref);
                    if (!subResult)
                        (0, superstruct_1.assert)(subResult, (0, superstruct_1.never)());
                    if (typeof subResult === "number" || typeof subResult === "string" || Object.entries(subResult).length) {
                        result[dataKey] = subResult;
                    }
                }
            });
        });
        return result;
    }
    return {};
}
function doFilterFacet(facets, filterConfig, facetKey) {
    const facet = facets[facetKey];
    const filter = filterConfig[facetKey];
    if (!facet || !filter) {
        return {};
    }
    if (typeof filter === "string") {
        if (filter === ".*") {
            Logger_1.default.debug("PASS whitelist filter allowing all", facetKey);
            return facet;
        }
        return {};
    }
    for (let i = 0; i < filter.length; i += 1) {
        const { conditions, output } = filter[i];
        if (evaluateCondition(facets, conditions, filterConfig.reference_list)) {
            Logger_1.default.debug("PASS whitelist condition", conditions);
            const filtered = doFilter(facet, output, filterConfig.reference_list, facetKey);
            if (Object.keys(filtered).length) {
                Logger_1.default.debug("PASS whitelist filter output rules", output);
                return filtered;
            }
        }
    }
    return {};
}
exports.doFilterFacet = doFilterFacet;
function doWhitelistFiltering(facets, filters = []) {
    const result = {};
    const dashboardIds = [];
    const collectionIds = [];
    filters.forEach((filter) => {
        Object.keys(facets)
            .filter((facetKey) => facetKey in FacetFilterService_1.FilteredFacet)
            .forEach((facetKey) => {
            const filteredFacet = doFilterFacet(facets, filter.filtering, facetKey);
            if (Object.keys(filteredFacet).length) {
                Logger_1.default.debug("Filtered facet", facetKey, filteredFacet);
                dashboardIds.push(filter.experiment_dashboard_id);
                collectionIds.push(filter.experiment_collection_id);
                (0, merge_1.default)(result, { [facetKey]: filteredFacet });
            }
        });
    });
    if (!Object.keys(result).length) {
        return undefined;
    }
    if (dashboardIds.length && collectionIds.length) {
        const experimentFacet = {
            dashboard_id: dashboardIds,
            collection_id: collectionIds,
        };
        (0, merge_1.default)(result, { experiment: experimentFacet });
    }
    const nonFilteredFacets = (0, pickBy_1.default)(facets, (value, key) => !(key in FacetFilterService_1.FilteredFacet));
    return (0, merge_1.default)(result, nonFilteredFacets);
}
exports.doWhitelistFiltering = doWhitelistFiltering;
